import React, { useContext, useEffect, useState } from 'react';

import EndpointCard from './EndpointCard';
import PbxContext from '../../context/PbxContext';

import { accessLocalStorage } from '../../services';

import Switch from 'react-bulma-switch/full';

import down from '../../sounds/down.mp3';
import up from '../../sounds/up.mp3';

const EndpointsList = () => {
  const getItensStateGlobal = useContext(PbxContext);
  const { endpoints, ipEndpoints } = getItensStateGlobal;
  const [showOffLine, setShowOffLine] = useState(true);


  const playSoundState = async (state) => {
    const audio = new Audio(state);
    await audio.play();
  }

  const changeStateOfflines = () => {
    if(showOffLine === true) return setShowOffLine(false);
    setShowOffLine(true);
    return;
  };

  const getInitialState  = () => {
    return document.getElementById(ipEndpoints.endpoint);
  };
  
  useEffect(() => {
    getInitialState();
  }, [ipEndpoints, showOffLine]);

    let newEndpoints = endpoints;
    if(!newEndpoints) newEndpoints = [];
    newEndpoints.sort((a, b) => a.resource - b.resource)
    const elementsPage = (
      <div className="columns is-multiline is-centered mx-2 mt-6">
            {
              newEndpoints.filter((endpoint) => {
                const sizeNameEndpoint = endpoint.resource;
                if(sizeNameEndpoint.length <= 4) {
                  return endpoint;
                }
                return null;
              }).map((endpoint) => {
                if(ipEndpoints.endpoint === endpoint.resource) {
                  const classNamed = endpoint.state === 'online' ? 'has-background-success' : 'has-background-primary-light';
                  endpoint = {
                    technology: endpoint.technology,
                    resource: endpoint.resource,
                    name: endpoint.name,
                    state: endpoint.state,
                    channel_ids: endpoint.channel_ids,
                    myClass: classNamed,
                    ip: ipEndpoints.ip,
                  };
                }
                return <EndpointCard key={endpoint.resource} endpoint={endpoint} />
              })
            }
      </div>);
    return (
      <div className="card body-div">
	<div className="column is-offset-11">
	  <p className="mx-3 has-text-weight-semibold">offline</p>
	  <Switch className="is-offset-8 mx-3 is-size-7" checked={showOffLine} rounded outlined onChange={() =>  changeStateOfflines()}/>
        </div>
        <div className="columns is-multiline is-centered mx-1 mt-1">
          {
            newEndpoints.filter((endpoint) => {
              const sizeNameEndpoint = endpoint.resource;
              // if(sizeNameEndpoint.length === 4) {
                if(!isNaN(Number(sizeNameEndpoint)) && sizeNameEndpoint.length === 4) {
                return endpoint;
              }
              return null;
            }).map((endpoint) => {
              if(ipEndpoints.endpoint === endpoint.resource) {
                const classNamed = endpoint.state === 'online' ? 'has-background-success' : 'has-background-primary-light';
                endpoint = {
                  technology: endpoint.technology,
                  resource: endpoint.resource,
                  name: endpoint.name,
                  state: endpoint.state,
                  channel_ids: endpoint.channel_ids,
                  myClass: classNamed,
                  ip: ipEndpoints.ip,
                };
              }
              return <EndpointCard key={endpoint.resource} endpoint={endpoint} show={showOffLine} />
            })
          }
         </div>
      </div>
    )
};

export default EndpointsList;

